import { OfertaArticulo } from './../ofertas-list.component';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Oferta } from "../ofertas-list.component";
import { Utils } from 'src/app/common/utils';

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

export async function createPdfListOfertas(logo, oferta: Oferta, fecha_actual) {

    let content_articulos = await fillTableArticulos(oferta.articulos, oferta.tipo_precio);

    let docDefinition: any = {
        pageSize: 'A4',
        pageMargins: [35, 35, 35, 35],
        styles: {
            texto_destacado: {
                bold: true
            },
            socio: {
                bold: true,
                fontSize: 8
            },
            parrafos_socio: {
                fontSize: 8
            },
            tabla_derecha: {
                alignment: "right"
            },
            parrafos_sociedad: {
                fontSize: 8,
                alignment: "center"
            },
            parrafos_mini_sociedad: {
                fontSize: 7,
                alignment: "center"
            },
            titulo20: {
                fontSize: 12,
                bold: true,
                alignment: "right",
                margin: [0, 0, 20, 0]
            },
            alinear_center: {
                alignment: "center"
            },
            alinear_derecha: {
                alignment: "right"
            },
            tabla_fecha: {
                fontSize: 10,
                alignment: "center",
                bold: true
            },
            obsevaciones_table: {
                bold: true,
                fontSize: 8
            },
            texto_categoria: {
                fontSize: 7
            },
            fondo_blanco: {
                background: '#ffffff'
            },
            tableFecha: {
                margin: [0, 5, 0, 0]
            }
        },
        content: [
            // Cabecera elegante (Logo izquierda, info cliente derecha)
            {
                columns: [
                    {
                        image: logo,
                        width: 140
                    },
                    {
                        stack: [
                            { text: (oferta ? oferta.nombre : '').toUpperCase(), bold: true, fontSize: 11, color: '#1b365d' },
                            { text: (oferta ? oferta.direccion : ''), fontSize: 9, margin: [0, 2, 0, 0] },
                            { text: (oferta ? oferta.poblacion : ''), fontSize: 9, margin: [0, 1, 0, 0] },
                            { text: (oferta ? oferta.provincia : ''), fontSize: 9, margin: [0, 1, 0, 0] },
                            { text: (oferta ? oferta.pais : ''), fontSize: 9, margin: [0, 1, 0, 0] },
                            { text: (oferta ? oferta.telefono : ''), fontSize: 9, margin: [0, 1, 0, 0], color: '#555555' }
                        ],
                        alignment: 'right'
                    }
                ],
                margin: [0, 0, 0, 20]
            },
            // Título de la oferta y fecha en la misma fila
            {
                columns: [
                    { text: 'ANGEBOT', fontSize: 18, bold: true, color: '#333333', alignment: 'left' },
                    { text: 'Datum: ' + fecha_actual, fontSize: 10, bold: true, color: '#555555', alignment: 'right', margin: [0, 6, 0, 0] }
                ],
                margin: [0, 10, 0, 5]
            },
            // Línea divisoria de diseño
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 0, y1: 0,
                        x2: 525, y2: 0,
                        lineWidth: 1,
                        strokeColor: '#333333'
                    }
                ],
                margin: [0, 5, 0, 15]
            },
            {
                text: 'DETAIL ARTIKEL', fontSize: 10, margin: [0, 0, 0, 10], color: '#333333', bold: true
            },
            // Tabla de artículos con diseño premium
            {
                table: {
                    widths: [45, 30, '*', 55, 35, 35, 35, 25, 25, 40, 40],
                    headerRows: 1,
                    body: content_articulos
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1.5 : 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0; // Sin bordes verticales para mayor claridad
                    },
                    hLineColor: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? '#333333' : '#e5e5e5';
                    },
                    paddingLeft: function (i, node) { return 4; },
                    paddingRight: function (i, node) { return 4; },
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; }
                }
            }
        ]
    }
    pdfMake.createPdf(docDefinition).open({}, window['Informe']);
}

function fillTableArticulos(articulos: OfertaArticulo[], tipo): Promise<any> {
    let content_table = [];
    return new Promise(async resolve => {
        let header = [
            { text: 'Foto', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Prod.', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Artikel', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Beschreibung', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Art.Nr.', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Topf', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Groesse', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Stk/Lage', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Stk/CC', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Preis' + ' ' + tipo, fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
            { text: 'Preis Mix', fillColor: '#555555', color: '#ffffff', bold: true, alignment: 'center', fontSize: 9 },
        ];
        content_table.push(header);
        for (let i = 0; i < articulos.length; i++) {
            let articulo = articulos[i];
            let row = new Array();
            var image = {};

            if (articulo.imagen == null || articulo.imagen.length == 0) {
                image = { text: '', fontSize: 8, alignment: 'center' };
            } else {
                image = { image: articulo.imagen ? articulo.imagen : '', width: (articulo.ancho / 1.5), height: (articulo.alto / 1.5), alignment: 'center' };
            }

            var proveedor = { text: articulo.proveedor ? articulo.proveedor : '', fontSize: 8, alignment: 'left' };
            var nombre = { text: articulo.nombre ? articulo.nombre : '', fontSize: 8, alignment: 'left' };
            var descripcion = { text: articulo.descripcion ? articulo.descripcion : '', fontSize: 8, alignment: 'left' };
            var maceta = { text: articulo.maceta ? articulo.maceta : '', fontSize: 8, alignment: 'center' };
            var tamanyo = { text: articulo.tamanyo ? articulo.tamanyo : '', fontSize: 8, alignment: 'center' };
            var unidades_piso = { text: articulo.unidades_piso ? articulo.unidades_piso : '', fontSize: 8, alignment: 'center' };
            var unidades_cc = { text: articulo.unidades_cc ? articulo.unidades_cc : '', fontSize: 8, alignment: 'center' };
            var precio = { text: articulo.precio ? (decimalFormat(articulo.precio, 2, '.', ',', 3)) + '€' : '', style: 'alinear_derecha', fontSize: 8, alignment: 'right' };
            var precio_mix = { text: articulo.precio_mix ? (decimalFormat(articulo.precio_mix, 2, '.', ',', 3)) + '€' : '', style: 'alinear_derecha', fontSize: 8, alignment: 'right' };
            var codcli = { text: articulo.codcli ? articulo.codcli : '', fontSize: 8, alignment: 'center' };

            row.push(image);
            row.push(proveedor);
            row.push(nombre);
            row.push(descripcion);
            row.push(codcli);
            row.push(maceta);
            row.push(tamanyo);
            row.push(unidades_piso);
            row.push(unidades_cc);
            row.push(precio);
            row.push(precio_mix);
            content_table.push(row);

            if ((i + 1) >= articulos.length) {
                resolve(content_table);
            }
        }
    });
}

function decimalFormat(input: any, nDecimals?: number, millar?: string, comma?: string, progressiveTo?: number) {
    if (!input) {
        return '';
    }
    return Utils.decimalFormat(input, nDecimals, millar, comma, progressiveTo);
}
